export var TextFontFamilies;
(function (TextFontFamilies) {
    TextFontFamilies["gothic"] = "\"all-round-gothic\", courier-new, sans-serif";
    TextFontFamilies["source"] = "\"source-sans-pro\", sans-serif";
    TextFontFamilies["poppins"] = "\"poppins\", sans-serif";
    TextFontFamilies["neuelKabel"] = "\"neue-kabel\", sans-serif";
    TextFontFamilies["ttCommonsPro"] = "\"tt-commons-pro\", sans-serif";
    TextFontFamilies["corporateS"] = "\"corporate-s\", sans-serif";
})(TextFontFamilies || (TextFontFamilies = {}));
export const TEXT_VARIANT = [
    "h",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "title1",
    "title2",
    "title3",
    "title4",
    "body",
    "body1",
    "body2",
    "body3",
    "body4",
    "button",
    "textFieldLabel",
    "textFieldBody",
];
export const TEXT_VARIANT_MAPPING = {
    h: "h1",
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    title1: "h6",
    title2: "h6",
    title3: "h6",
    title4: "h6",
    body: "p",
    body1: "p",
    body2: "p",
    body3: "p",
    body4: "p",
    button: "p",
    textFieldLabel: "p",
    textFieldBody: "p",
};
//# sourceMappingURL=text.js.map